<template>
  <div class="modalWrapper" @click="close">
    <div class="modalBlock">
      <div class="confirmTitle">
        {{ $t(`home.countdown.you_here`) }}
      </div>
      <div
        class="confirmText"
        v-html="
          $t(`home.countdown.you_here_text`, {
            seconds: time
          })
        "
      ></div>
      <div class="confirmActions">
        <div class="confirmBtn" @click="close">
          {{ $t(`home.countdown.continue`) }}
        </div>
      </div>
    </div>
    <div class="modalBackdrop"></div>
  </div>
</template>
<script>
export default {
  props: {
    onClose: Function,
    onConfirm: Function
  },
  data() {
    return {
      time: 20,
      interval: null
    };
  },
  methods: {
    clear() {
      clearInterval(this.interval);
      this.time = 20;
    },
    close() {
      this.clear();
      this.$emit("onClose");
    },
    confirm() {
      this.clear();
      this.$emit("onConfirm");
    }
  },
  created() {
    this.interval = setInterval(() => {
      if (this.time > 0) {
        this.time -= 1;
      } else {
        this.confirm();
      }
    }, 1000);
  }
};
</script>
<style lang="scss" scoped>
.modalWrapper {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 1500;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.modalBlock {
  position: fixed;
  z-index: 1600;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 550px auto;
  width: 750px;
  height: 410px;
  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 4px 4px 25px #00000033;
  border-radius: var(--component_modals_countdown_modalBlock_border-radius);
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 95px 30px 75px 30px;
  color: black;
  justify-content: flex-start;
}

.modalBackdrop {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1550;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.confirmActions {
  display: flex;
  justify-content: space-around;
}

.confirmBtn {
  width: 210px;
  height: 70px;
  border-radius: var(--component_modals_countdown_confirmBtn_border-radius);
  background-color: var(
    --component_modals_countdown_confirmBtn_background-color
  );
  color: var(--component_modals_countdown_confirmBtn_color);
  font-size: var(--component_modals_countdown_confirmBtn_font-size);
  font-family: var(--component_modals_countdown_confirmBtn_font-family);
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.6px;
  padding: var(--component_modals_countdown_confirmBtn_padding);
  text-transform: var(--component_modals_countdown_confirmBtn_text-transform);
}

.confirmTitle {
  color: var(--component_modals_countdown_confirmTitle_color);
  font-size: var(--component_modals_countdown_confirmTitle_font-size);
  font-family: var(--component_modals_countdown_confirmTitle_font-family);
  text-transform: var(--component_modals_countdown_confirmTitle_text-transform);
  padding-bottom: 10px;
}

.confirmText {
  font-size: var(--component_modals_countdown_confirmText_font-size);
  font-family: var(--component_modals_countdown_confirmText_font-family);
  padding-bottom: 50px;
  line-height: 32px;
}
</style>
<style lang="scss">
.confirmText {
  span.ModalCountdownTime {
    color: var(
      --component_modals_countdown_confirmText_ModalCountdownTime_color
    );
    font-weight: var(
      --component_modals_countdown_confirmText_ModalCountdownTime_font-weight
    );
  }
  span.ModalCountdownTimeUnit {
    color: var(
      --component_modals_countdown_confirmText_ModalCountdownTimeUnit_color
    );
    font-weight: var(
      --component_modals_countdown_confirmText_ModalCountdownTimeUnit_font-weight
    );
  }
}
</style>
